<div class="message">{{ message }}</div>
<div class="actions">
  <a class="btn btn-primary btn-sm" (click)="onConfirm()">{{ confirmText }}</a>
  <a class="btn btn-primary btn-outline btn-sm ml-1" (click)="onCancel()">{{ cancelText }}</a>
</div>
